<app-checkbox-control
	[label]="label()"
	[controlName]="controlName()"
	[formGroup]="formGroup()"
	[required]="required()"
/>
